import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: '', redirectTo: 'backoffice', pathMatch: 'full' },
  { path: 'backoffice', loadChildren: () => import(`@vfa-cp/backoffice`).then(m => m.BackofficeModule) },
  { path: '**', redirectTo: 'core/error/404' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
